const findModal = (id) => document.querySelector(`[data-modal-id="${id}"]`)

const initModal = () => {
  const showModal = (modal) => {
    // Remove any pending closing state first
    modal.classList.remove('modal--closing')

    // Make modal visible before starting animation
    modal.classList.remove('hidden')
    requestAnimationFrame(() => {
      modal.classList.add('modal--open')
      document.body.classList.add('overflow-hidden') // Prevent background scrolling
    })

    // Auto-focus first visible input
    const firstInput = modal.querySelector(
      'input:not([type="hidden"]):not([disabled]), textarea:not([disabled])'
    )
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 120)
    }
  }

  const hideModal = (modal) => {
    modal.classList.remove('modal--open')
    modal.classList.add('modal--closing')

    // Wait for transition to finish before fully hiding
    const timeout = setTimeout(() => {
      modal.classList.add('hidden')
      modal.classList.remove('modal--closing')
    }, 220)

    // Ensure scroll is restored even if transition is interrupted
    modal.addEventListener(
      'transitionend',
      () => {
        clearTimeout(timeout)
        modal.classList.add('hidden')
        modal.classList.remove('modal--closing')
        document.body.classList.remove('overflow-hidden')
      },
      { once: true }
    )

    // Fallback restore for browsers that might not fire transitionend
    setTimeout(() => document.body.classList.remove('overflow-hidden'), 230)
  }

  // Delegated, and bound once, so triggers that appear after init still work —
  // Swiper's loop clones its slides on init, and cloneNode drops listeners.
  if (!document.body.dataset.modalDelegated) {
    document.body.dataset.modalDelegated = 'true'

    document.addEventListener('click', (e) => {
      const closer = e.target.closest?.('[data-modal-close]')
      if (closer) {
        const modal = findModal(closer.getAttribute('data-modal-close'))
        if (modal) hideModal(modal)
        return
      }

      const opener = e.target.closest?.('[data-modal-target]')
      if (opener) {
        const modal = findModal(opener.getAttribute('data-modal-target'))
        if (modal) showModal(modal)
        return
      }

      // Clicking the shell itself — i.e. outside the panel — closes it.
      if (e.target.matches?.('[data-modal-id]')) hideModal(e.target)
    })

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const open = document.querySelector('[data-modal-id].modal--open')
        if (open) hideModal(open)
        return
      }

      if (e.key !== 'Enter' && e.key !== ' ') return

      const opener = e.target.closest?.('[data-modal-target]')
      // A div with role="button" doesn't synthesise click from the keyboard, so
      // focusable cards would otherwise be dead for keyboard users. Real buttons
      // and links do synthesise it — handling them here would open twice.
      if (!opener || opener.matches('a, button')) return

      e.preventDefault() // Space would scroll the page
      const modal = findModal(opener.getAttribute('data-modal-target'))
      if (modal) showModal(modal)
    })
  }

  // Auto-open any modal flagged for load (e.g., flash modal)
  document
    .querySelectorAll('[data-modal-id][data-auto-open="true"]')
    .forEach((modal) => showModal(modal))
}

export default initModal
